angular.module('bmsApp.crm.customer').controller('CustomerViewCorrespondencesCtrl', function ($scope,
																							  $state,
																							  ngTableParams,
																							  EmailSvc) {

	$scope.tabs.correspondences.select = function () {
		var emailParams = {
			filter: {
				customer: $scope.customer.id
			}
		};
		EmailSvc.index(emailParams).then(function (response) {
			console.info(response.data);
		});
	};

	angular.extend($scope.tabs.correspondences, {
		select: function () {
			if ($scope.tabs.correspondences.loaded !== true) {
				$scope.correspondences = {
					loading: true,
					filters: {
						customer: $scope.customer.id
					},
					data: {},
					tableParams: new ngTableParams({
						page: 1,
						count: $scope.config.tabbedTable.params.count
					}, {
						counts: $scope.config.tabbedTable.settings.counts,
						getData: function ($defer, params) {
							$scope.correspondences.loading = true;
							EmailSvc.index(params.$params).then(function (response) {
								$defer.resolve(response.data.email_collection);
								params.total(response.data.email_total_count);
								$scope.correspondences.data.emailAccountTotalCount = response.data.email_account_total_count;
								$scope.correspondences.data.emailTotalCount = response.data.email_total_count;
								$scope.correspondences.loading = false;
							});
						}
					}),
					applyFilter: function () {
						angular.extend($scope.correspondences.tableParams.$params.filter, $scope.correspondences.filters);
					},
					rowClicked: function (email) {
						$state.go('main.crm.customer.index.emailView', {
							emailId: email.id
						});
					}
				};

				$scope.correspondences.applyFilter();
				$scope.tabs.correspondences.loaded = true;
			}
		}
	});

});
